import { jsPDF } from "jspdf";
import moment from 'moment';
import Moment from 'moment-business-days';
import 'moment/locale/es-mx';
import { useEffect, useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate, useParams } from "react-router-dom";
import SignatureCanvas from 'react-signature-canvas';
import aprobadorService from "../services/aprobador.service";
import calculoService from "../services/calculo.service";
import causalService from "../services/causal.service";
import correoService from "../services/correo.service";
import desvinculadoService from "../services/desvinculado.service";
import emailService from "../services/email.service";
import reclutamientoService from "../services/reclutamiento.service";

import { SnackbarProvider, useSnackbar } from 'notistack';
import { Oval } from 'react-loader-spinner';
import BeatLoader from 'react-spinners/BeatLoader';

/** Material UI */
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from "@mui/material/FormControl";
import Grid from '@mui/material/Grid';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Modal from '@mui/material/Modal';
import Select from "@mui/material/Select";
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid, esES } from '@mui/x-data-grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import esLocale from 'date-fns/locale/es';
import personaService from "../services/persona.service";

/** Estilos CSS MUI */
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

// Array con los días festivos de cada mes (ejemplo de muestra)
// Nótese que si un mes no tiene festivos debemos incluir igualmente un array vacío, (ejemplo: Noviembre)
const festivos = [[2], [], [], [7,8], [1, 21], [21, 26], [16], [15], [18, 19], [9, 27], [1], [8, 25]];

function calculaEntrega(diaPedido, diasPactados, festivos) {
    // diaPropuesto: almacena el mismo valor de diaPedido, en caso que diasPactados = 0, la función 
    // devolverá el valor de diaPedido (para mi tiene lógica)
    let diaPropuesto = new Date(diaPedido.getFullYear(), diaPedido.getMonth(), diaPedido.getDate());

    // iniciamos un contador en 1 para calcular la fecha de diaPropuesto.
    let i = 1;

    // El siguiente bucle se ejecutará hasta que se consuman los diasPactados
    while (diasPactados > 0) {
        // En cada iteración asumimos que el día no es festivo
        let festivo = false;
        // incrementamos en 1 el diaPropuesto para efectuar las verificaciones
        diaPropuesto = new Date(diaPedido.getFullYear(), diaPedido.getMonth(), diaPedido.getDate() + i);
        // Nótese que usamos formato ISO y solo incrementamos el día, dejando el mes y el año iguales
        // Alguien preguntará: ¿Y que pasa si la fecha es, digamos, 31 de Enero y le aumentamos 1 día?
        // Pues la respuesta lógica es que daría 32 de Enero, lo cual no es una fecha válida.
        // Sin embargo, JavaScript es un poco mas atento que nosotros y simplemente realiza la aritmética
        // necesaria para convertir el 32 de Enero en 01 de Febrero, y así nos salva el pellejo.
        // Véase bien que usamos los métodos getFullYear(), getMonth() y getDate().
        // Esto funciona siempre y cuando hagamos la construcción del objeto Date de esta manera.
        // Ya irá alguno de avispado y pondrá: fecha = new Date('2019-01-32'); lo cual le dará 'fecha inválida'
        // Alguien un poco mas versado puede aclarar este asunto, pero no es el objetivo en este momento.

        if (diaPropuesto.getDay() > 0 && diaPropuesto.getDay() < 6) {
            // Aquí hemos usado el método getDay() del objeto Date, este método devuelve un valor entero entre 0 y 6,
            // donde 0: Domingo, 1: Lunes, ... , 6: Sabado.
            // Los días laborables van del 1 al 5 (ambos inclusive)

            // Si el día es laborable debemos entonces verificar si es festivo

            // Aquí es importante que entendamos lo siguiente:
            //  * Por cada iteración debemos obtener el mes en el que estamos comprobando el festivo
            //  * Vamos a comparar el día propuesto con el Array de festivos, usando el mes correspondiente

            let m = diaPropuesto.getMonth();
            let dia = diaPropuesto.getDate();

            // Felizmente para nosotros el método getMonth() devuelve un entero entre 0 y 11, que se
            // corresponde con cada mes del año, y digo felizmente, porque los índices de nuestro Array
            // van de 0 a 11 también.

            for (let d in festivos[m]) {
                if (dia === festivos[m][d]) {
                    festivo = true;
                    //Aquí no hay mucho que aclarar, si es festivo ya no sigo comprobando el resto del mes.
                    break;
                }
            } // Fin bucle for

            if (!festivo) {
                // Si las condiciones son: Laborable y No Festivo, descuento el diaPactado.
                diasPactados--;
            }
        }

        // Por último, debemos incrementar el número de días que sumaremos al diaPropuesto
        // en cada iteración
        i++;
    } // Fin de bucle while

    // Devolvemos el resultado
    return diaPropuesto;

} // Fin función

const Finiquitopt3 = () => {
    const { id_causal } = useParams();
    const [persona, setPersona] = useState('');
    const [causal, setCausal] = useState('');
    const [aprobado, setAprobado] = useState([]);
    const [calculo, setCalculo] = useState([]);
    const [prestamo, setPrestamo] = useState('');
    const [detallePrestamo, setDetallePrestamo] = useState('');
    const [equipo, setEquipo] = useState('');
    const [detalleEquipo, setDetalleEquipo] = useState('');
    const [rendir, setRendir] = useState('');
    const [detalleRendir, setDetalleRendir] = useState('');
    const [sigPad, setSigPad] = useState({});
    const [parrafo, setParrafo] = useState('');
    const [aviso, setAviso] = useState(false);
    const [fechaplazo, setFechaPlazo] = useState('');
    const [correos, setCorreos] = useState([]);
    const navigate = useNavigate();
    const [fechaterminoproyecto, setFechaTerminoProyecto] = useState('');
    const [fechaterminocontrato, setFechaTerminoContrato] = useState('');
    const [fechainicioproyecto, setFechaInicioProyecto] = useState('');
    const [hito, setHito] = useState('');
    const [clausula, setClausula] = useState('');
    const [dia1, setDia1] = useState('');
    const [dia2, setDia2] = useState('');
    const [dia3, setDia3] = useState('');
    const [mes, setMes] = useState('');
    const [motivorechazo, setMotivoRechazo] = useState('');
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fechafiniquito, setFechafiniquito] = useState('');
    const [loadginButton, setLoadingbutton] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        console.log(id_causal);
        causalService.getId(id_causal)
            .then(c => {
                console.log(c);
                setCausal(c.data);
                setAprobado(c.data.aprobado);
                setPersona(c.data.persona);
                retreiveCalculo(id_causal);
                retreiveCorreos();
            })
            .catch(err => {
                console.log(err);
            });
    }, []);

    const limpiarFirma = () => {
        sigPad.clear();
    }

    const closeModal = () => setOpen(false);

    const openModal = () => setOpen(true);

    function retreiveCalculo(idc) {
        calculoService.getByIdCausal(idc)
            .then(resp => {
                console.log(resp.data);
                setCalculo(resp.data);
                resp.data.map(c => {
                    setFechafiniquito(c.fecha_finiquito);
                    if (c.nombre === "Prestamos vigentes (Finanzas)") {
                        setPrestamo(c.valor);
                        setDetallePrestamo(c.detalle);
                    }
                    if (c.nombre === "Entrega de equipos (Secretaria)" && c.tipo === "FINANZAS") {
                        setEquipo(c.valor);
                        setDetalleEquipo(c.detalle);
                    }
                    if (c.nombre === "Fondo por rendir (Finanzas)") {
                        setRendir(c.valor);
                        setDetalleRendir(c.detalle);
                    }
                })
            })
            .catch(err => {
                console.error(err);
            });
    }

    function retreiveCorreos() {
        correoService.getAll()
            .then(resp => {
                console.log(resp.data);
                setCorreos(resp.data);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const finalizar = () => {
        if (persona.estado_desv === "Desvinculado") {
            alert("La persona ya se encuentra desvinculada!!");
            return;
        }
        if (!prestamo) {
            alert("Debe ingresar una opción en Prestamos Vigentes e ingresar temporalmente");
            return;
        }
        if (!equipo) {
            alert("Debe ingresar una opción en Entrega de equipos e ingresar temporalmente");
            return;
        }
        if (!rendir) {
            alert("Debe ingresar una opción en Fondos por rendir e ingresar temporalmente");
            return;
        }
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma e ingresar temporalmente");
            return;
        }
        setLoading(true);
        desvinculadoService.ingresar({ personaId: persona.id, fecha_desvinculacion: new Date() })
            .then(resp => {
                console.log(resp);
                //Actualizamos el estado en Desvinculaciones
                personaService.update(persona.id, { estado_desv: "Desvinculado" })
                    .then(res => {
                        console.log(res);
                        setLoading(false);
                        enqueueSnackbar("Trabajador desvinculado de personal!!", { variant: 'success' });
                    })
                    .catch(err => {
                        console.error(err);
                        setLoading(false);
                        enqueueSnackbar("Ha ocurrido un Error!", { variant: 'error' });
                    });
                //Actualizamos el estado en reclumatiento
                reclutamientoService.getUsuarioPorRut(persona.rut)
                    .then(resp => {
                        if (resp.data.length !== 0) {
                            reclutamientoService.updateTrabajador(resp.data[0].id, { estado: "Desvinculado" })
                                .then(up => {
                                    console.log(up);
                                    setLoading(false);
                                    enqueueSnackbar("Trabajador desvinculado de reclutamiento!!", { variant: 'success' });
                                }).catch(err => {
                                    console.error(err);
                                    setLoading(false);
                                    enqueueSnackbar("Ha ocurrido un Error!", { variant: 'error' });
                                })
                        }
                    }).catch(err => {
                        console.error(err);
                        setLoading(false);
                        enqueueSnackbar("Ha ocurrido un Error!", { variant: 'error' });
                    });
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
                enqueueSnackbar("Ha ocurrido un Error!", { variant: 'error' });
            });
        /* toast.success("Proceso de Desvinculación Finalizada!!", {
            style: {
                borderRadius: 5
            }
        });
        setTimeout(() => {
            navigate("/Salidarrhh");
        }, 6000); */
    }

    const Ingresar = async () => {
        var arr_ingreso = [];
        var contador = 0;
        if (!prestamo) {
            alert("Debe ingresar una opción en Prestamos Vigentes");
            return;
        }
        if (!equipo) {
            alert("Debe ingresar una opción en Entrega de equipos");
            return;
        }
        if (!rendir) {
            alert("Debe ingresar una opción en Fondos por rendir");
            return;
        }
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        if (prestamo) {
            arr_ingreso.push({ nombre: "Prestamos vigentes (Finanzas)", valor: prestamo, detalle: detallePrestamo, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        if (equipo) {
            arr_ingreso.push({ nombre: "Entrega de equipos (Secretaria)", valor: equipo, detalle: detalleEquipo, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        if (rendir) {
            arr_ingreso.push({ nombre: "Fondo por rendir (Finanzas)", valor: rendir, detalle: detalleRendir, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        setLoading(true);
        for (var i in arr_ingreso) {
            var cl = calculo.find(v => v.nombre === arr_ingreso[i].nombre);
            if (cl) {
                let cup = await calculoService.update(cl.id, arr_ingreso[i]);
                console.log("UPDATE", cup.data.message);
                contador++;
            } else {
                let cal = await calculoService.ingresar(arr_ingreso[i]);
                console.log(cal);
                if (cal) {
                    contador++;
                }
            }
        }

        var f = sigPad.toDataURL();
        var fr = f.split(',');

        console.log("Contador", contador);

        const dataap = {
            tipo: "FINANZAS",
            fecha: Date.now(),
            firma: fr[1],
            id_causal: causal.id
        }

        console.log("Aprobador", aprobado);
        if (contador === arr_ingreso.length) {
            if (aprobado) {
                var ap = aprobado.find(v => v.tipo === "FINANZAS");
                if (ap) {
                    //Actualizamos
                    aprobadorService.update(ap.id, dataap)
                        .then(resp => {
                            console.log(resp.data.message);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                } else {
                    //Creamos el aprobador
                    aprobadorService.ingresar(dataap)
                        .then(a => {
                            console.log(a);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            } else {
                //Creamos el aprobador
                aprobadorService.ingresar(dataap)
                    .then(a => {
                        console.log(a);
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }


        //Enviamos email
        var crr = correos.filter(v => v.destino === "FINANZAS2"); //FINANZAS2 //CJARAMILLO
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        }
        var html = crearHtmlEnvio(new Date().toString(), id_causal, persona);
        const _data_mail = {
            nombre: "RRHH",
            //from_name: "Encuesta Salud Ecora S.A.",
            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
            email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
        }
        personaService.update(persona.id, {estado_desv: "En Finanzas 2"}).then(resp=>{
            console.log(resp);
            emailService.sendMail(_data_mail)
            .then(response => {
                console.log(response);
                setLoading(false);
                toast.success("Ingreso exitoso!", {
                    style: {
                        borderRadius: 5
                    }
                });
                setTimeout(() => {
                    navigate("/salidar");
                }, 3000);
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
        }).catch(err=>{
            console.error(err);
            setLoading(false);
            toast.error("Ocurrio un error");
        });
        

    };

    const Ingresar_cdiaz = async () => {
        var arr_ingreso = [];
        var contador = 0;
        if (!prestamo) {
            alert("Debe ingresar una opción en Prestamos Vigentes");
            return;
        }
        if (!equipo) {
            alert("Debe ingresar una opción en Entrega de equipos");
            return;
        }
        if (!rendir) {
            alert("Debe ingresar una opción en Fondos por rendir");
            return;
        }
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        if (prestamo) {
            arr_ingreso.push({ nombre: "Prestamos vigentes (Finanzas)", valor: prestamo, detalle: detallePrestamo, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        if (equipo) {
            arr_ingreso.push({ nombre: "Entrega de equipos (Secretaria)", valor: equipo, detalle: detalleEquipo, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        if (rendir) {
            arr_ingreso.push({ nombre: "Fondo por rendir (Finanzas)", valor: rendir, detalle: detalleRendir, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        setLoading(true);
        for (var i in arr_ingreso) {
            var cl = calculo.find(v => v.nombre === arr_ingreso[i].nombre);
            if (cl) {
                let cup = await calculoService.update(cl.id, arr_ingreso[i]);
                console.log("UPDATE", cup.data.message);
                contador++;
            } else {
                let cal = await calculoService.ingresar(arr_ingreso[i]);
                console.log(cal);
                if (cal) {
                    contador++;
                }
            }
        }

        var f = sigPad.toDataURL();
        var fr = f.split(',');

        console.log("Contador", contador);

        const dataap = {
            tipo: "FINANZAS2",
            fecha: Date.now(),
            firma: fr[1],
            id_causal: causal.id
        }

        console.log("Aprobador", aprobado);
        if (contador === arr_ingreso.length) {
            if (aprobado) {
                var ap = aprobado.find(v => v.tipo === "FINANZAS2");
                if (ap) {
                    //Actualizamos
                    aprobadorService.update(ap.id, dataap)
                        .then(resp => {
                            console.log(resp.data.message);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                } else {
                    //Creamos el aprobador
                    aprobadorService.ingresar(dataap)
                        .then(a => {
                            console.log(a);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            } else {
                //Creamos el aprobador
                aprobadorService.ingresar(dataap)
                    .then(a => {
                        console.log(a);
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }


        //Enviamos email
        var crr = correos.filter(v => v.destino === "GERENCIA" && v.proyecto === persona.ctoDescripcion); //FINANZAS2 //CJARAMILLO
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        }
        var html = crearHtmlGerencia(new Date().toString(), causal.nombre,id_causal, persona);
        const _data_mail = {
            nombre: "GERENCIA",
            //from_name: "Encuesta Salud Ecora S.A.",
            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
            email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
        }
        personaService.update(persona.id, {estado_desv: "En Gerencia Op"}).then(resp=>{
            console.log(resp);
            emailService.sendMail(_data_mail)
            .then(response => {
                console.log(response);
                setLoading(false);
                toast.success("Ingreso exitoso!", {
                    style: {
                        borderRadius: 5
                    }
                });
                setTimeout(() => {
                    navigate("/salidar");
                }, 3000);
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
        }).catch(err=>{
            console.error(err);
            setLoading(false);
            toast.error("Ocurrio un error");
        });
    }

    function crearHtmlGerencia(fecha, causal, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, para la cual se necesita su aprobación a traves del siguiente link: </p> <a href='${baseurl}/finiquitoger/${id_causal}'>${persona.Rut + ' - ' + persona.perNombre1 + ' ' + persona.perApPaterno}</a> \n <p>con Causal: ${causal} </p>`;
        html = html + "</div>";
        return html;
    }

    const Ingresar_cjaramillo = async () => {
        var arr_ingreso = [];
        var contador = 0;
        if (!prestamo) {
            alert("Debe ingresar una opción en Prestamos Vigentes");
            return;
        }
        if (!equipo) {
            alert("Debe ingresar una opción en Entrega de equipos");
            return;
        }
        if (!rendir) {
            alert("Debe ingresar una opción en Fondos por rendir");
            return;
        }
        if (sigPad.isEmpty()) {
            alert("Ingrese Firma");
            return;
        }
        if (prestamo) {
            arr_ingreso.push({ nombre: "Prestamos vigentes (Finanzas)", valor: prestamo, detalle: detallePrestamo, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        if (equipo) {
            arr_ingreso.push({ nombre: "Entrega de equipos (Secretaria)", valor: equipo, detalle: detalleEquipo, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        if (rendir) {
            arr_ingreso.push({ nombre: "Fondo por rendir (Finanzas)", valor: rendir, detalle: detalleRendir, fecha_mod: new Date(), tipo: "FINANZAS", id_causal: causal.id, fecha_finiquito: fechafiniquito })
        }
        setLoading(true);
        for (var i in arr_ingreso) {
            var cl = calculo.find(v => v.nombre === arr_ingreso[i].nombre);
            if (cl) {
                let cup = await calculoService.update(cl.id, arr_ingreso[i]);
                console.log("UPDATE", cup.data.message);
                contador++;
            } else {
                let cal = await calculoService.ingresar(arr_ingreso[i]);
                console.log(cal);
                if (cal) {
                    contador++;
                }
            }
        }

        var f = sigPad.toDataURL();
        var fr = f.split(',');

        console.log("Contador", contador);

        const dataap = {
            tipo: "CJARAMILLO",
            fecha: Date.now(),
            firma: fr[1],
            id_causal: causal.id
        }

        console.log("Aprobador", aprobado);
        if (contador === arr_ingreso.length) {
            if (aprobado) {
                var ap = aprobado.find(v => v.tipo === "CJARAMILLO");
                if (ap) {
                    //Actualizamos
                    aprobadorService.update(ap.id, dataap)
                        .then(resp => {
                            console.log(resp.data.message);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                } else {
                    //Creamos el aprobador
                    aprobadorService.ingresar(dataap)
                        .then(a => {
                            console.log(a);
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            } else {
                //Creamos el aprobador
                aprobadorService.ingresar(dataap)
                    .then(a => {
                        console.log(a);
                    })
                    .catch(err => {
                        console.error(err);
                    });
            }
        }


        //Enviamos email
        var crr = correos.filter(v => v.destino === "FINANZAS3"); //FINANZAS2
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        }
        var html = crearHtmlEnvioFinal(new Date().toString(), id_causal, persona);
        const _data_mail = {
            nombre: "RRHH",
            //from_name: "Encuesta Salud Ecora S.A.",
            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
            email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
        }
        personaService.update(persona.id, {estado_desv: "En Finanzas 3 (Finiquito)"}).then(resp=>{
            console.log(resp);
            emailService.sendMail(_data_mail)
            .then(response => {
                console.log(response);
                setLoading(false);
                toast.success("Ingreso exitoso!", {
                    style: {
                        borderRadius: 5
                    }
                });
                setTimeout(() => {
                    navigate("/salidar");
                }, 3000);
            })
            .catch(e => {
                console.error(e);
                setLoading(false);
            });
        }).catch(err=>{
            console.error(err);
            setLoading(false);
            toast.error("Ocurrio un error");
        });
        

    }

    const descargar_carta = () => {
        window.open("https://docrecluta.s3.sa-east-1.amazonaws.com/FORMAT_DESV.pdf");
    }

    const crear_carta = () => {
        if (aviso) {
            console.log("Aviso", aviso);
        }
        console.log(persona);
        if (causal.nombre === "Art 159 N4") {
            pdf1594(parrafo);
        } else if (causal.nombre === "Art 161 N1") {
            if (aviso) {
                if (!fechaplazo) {
                    alert("Falta ingresar la fecha de plazo");
                    return;
                }
                pdf1611CA(parrafo);
            } else {
                pdf1611SA(parrafo);
            }
        } else if (causal.nombre === "Art 159 N5") {
            if (!fechaterminoproyecto) {
                alert("Debe ingresasr la fecha de termino de proyecto");
                return;
            }
            if (!fechaterminocontrato) {
                alert("Debe ingresasr la fecha de termino de contrato");
                return;
            }
            if (!fechainicioproyecto) {
                alert("Debe ingresasr la fecha de inicio de proyecto");
                return;
            }
            if (!hito) {
                alert("Debe ingresasr el hito");
                return;
            }
            if (!clausula) {
                alert("Debe ingresasr la clausula");
                return;
            }
            pdf1595("");
        } else if (causal.nombre === "Art 160 N3") {
            //Causal 1603
            if (!dia1 || !dia2) {
                alert("Debe ingresar los días y el mes");
                return;
            }
            pdf1603("");
        } else if (causal.nombre === "Art 159 N1") {
            pdf1591("");
        } else {
            //PDF Generico
            var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
            var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
            var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");
            //var fecha_fin = moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY");
            var fecha_10 = Moment(calculo[0].fecha_finiquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
            const doc = new jsPDF("p", "pt", "letter", true);
            doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
            doc.setFontSize(12);
            doc.setFont("", "bold");
            doc.text("Antofagasta", 375, 70);
            doc.setFont("", "normal");
            var xt = doc.getTextDimensions("Antofagasta").w;
            doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 375 + xt + 5, 70);
            doc.text("Estimada(o):", 40, 170);
            doc.text(nombre_completo, 40, 190);
            doc.text("Rut:", 40, 210);
            doc.text(persona.Rut, 70, 210);
            doc.setFont("", "bold");
            doc.text("Presente", 40, 250);
            var parrafo1 = `La presente tiene por motivo, informar a Usted que con fecha ${fecha_fin}, se pone término al Contrato de Trabajo que usted tenía vigente con nuestra Empresa. El término de dicho Contrato se acoge al ${causal.descripcion}`;
            var parrafo2 = `Le informamos que sus cotizaciones previsionales se encuentran debidamente enteradas en las entidades correspondientes.`;
            var parrafo3 = `Su finiquito estará disponible a partir desde el ${fecha_fin_10}, en nuestras oficinas ubicadas en Calle Baquedano 647, Ciudad de Antofagasta.`;
            var parrafo_add = "";
            if (parrafo !== "") {
                parrafo_add = 'Dicha causal se funda en ' + parrafo;
            }
            doc.setFont("", "normal");
            var y = 280;
            doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
            //console.log("PARRAFO ADD ", parrafo_add);
            let split = parrafo_add.split('\n\n') //split up
            //logging every new line:
            split.forEach(function (item) {
                //console.log(item);
                doc.text(item, 40, y, { maxWidth: 500, align: 'justify' });
                y = y + (doc.getTextDimensions(item).h * (doc.getTextDimensions(item).w / 500)) + 12 + 20;
                console.log(y);
                if (y >= 660) {
                    doc.addPage();
                    y = 50;
                }
            });
            /* doc.text(parrafo_add, 40, y, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(parrafo_add).h * (doc.getTextDimensions(parrafo_add).w / 500)) + 12 + 20; */
            doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20;
            if (y >= 660) {
                doc.addPage();
                y = 50;
            }
            doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
            var text = "Sin otro particular, Atte.,",
                xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
            doc.text(text, xOffset, 680);
            doc.setFont("", "bold");
            var text2 = "Depto. R.R.H.H.",
                xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
            doc.text(text2, xOffset2, 700);
            var text3 = "Constructora Ecora S.A.",
                xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
            doc.text(text3, xOffset3, 720);
            var text4 = "Rut.: 76.961.000-6",
                xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
            doc.text(text4, xOffset4, 740);
            var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
                xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
            doc.text(text5, xOffset5, 760);
            doc.output("dataurlnewwindow", "carta_desvinculacion.pdf");
        }

        //pdf1601CA(parrafo);
        //pdf1601SA("");
    }

    const rechazar = () => {
        if (!motivorechazo) {
            alert("Debe ingresar un motivo de rechazo");
            return;
        }
        //Enviamos email
        var crr = correos.filter(v => v.destino === "RRHH");
        var send = [];
        if (crr) {
            for (var i in crr) {
                send.push(crr[i].correo);
            }
        }
        var html = crearHtml(new Date().toString(), id_causal, motivorechazo);
        const _data_mail = {
            nombre: "RRHH",
            //from_name: "Encuesta Salud Ecora S.A.",
            mensaje: html,//"Con fecha " + new Date().toString() + " se ha generado un desvinculación, para la cual se necesita completar a traves del siguiente link: http://ecoraapp.com/inicio/15740886-0 \n con Causal: " + state.causal,
            email: send//["plagues@ecora.cl", "mlillo@ecora.cl"]//persona.perCorreo
        }
        emailService.sendMail(_data_mail)
            .then(response => {
                console.log(response);
            })
            .catch(e => {
                console.log(e);
            });

        setOpen(false);
        navigate("/salida");
    }

    function crearHtml(fecha, id_causal, motivo_rechazo) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:whitesmoke;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Rechazo de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado un rechazo a la desvinculación por el siguiento motivo: ${motivo_rechazo}, por favor revisar a traves del siguiente link: ${baseurl}/finiquitopt2/${id_causal} \n`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlEnvio(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Modificación de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una modificación a la desvinculación, por favor revisar a traves del siguiente link: </p> <a href="${baseurl}/finiquitofin2/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlEnvioFinal(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Modificación de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una modificación a la desvinculación, por favor revisar a traves del siguiente link: </p> <a href="${baseurl}/finiquitofinalizar/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    function crearHtmlGG(fecha, id_causal, persona) {
        const currentURL = window.location.host;
        const protocol = window.location.protocol;
        const baseurl = protocol + "//" + currentURL;
        var html = "<div style='text-align:center;padding:20px;margin-right:auto;margin-left:auto;border-radius:5px;width:90%;background-color:#90c7fe;border:#a3a3a3 1px solid;'>";
        html = html + "<center><h3>Aviso de Desvinculación</h3></center><br/>";
        html = html + `<p>Con Fecha ${moment(fecha).format("DD-MM-YYYY")} se ha generado una desvinculación, la cual requiere de su revisión y aprobación, por favor revisar a traves del siguiente link: </p> <a href="${baseurl}/finiquitogergen/${id_causal}">${persona.Rut + " - " + persona.perNombre1 + " " + persona.perApPaterno}</a> \n`;
        html = html + "</div>";
        return html;
    }

    function pdf1611CA(parrafo) {
        var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
        var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
        var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");
        //var fecha_fin = moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY");
        var fecha_10 = Moment(calculo[0].fecha_finiquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_plazo = moment(fechaplazo).locale('es').format("DD-MMMM-YYYY");
        const doc = new jsPDF("p", "pt", "letter", true);
        doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
        doc.setFontSize(12);
        doc.setFont("", "bold");
        doc.text("Antofagasta", 375, 70);
        doc.setFont("", "normal");
        doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 440, 70);
        doc.text("Estimada(o):", 40, 170);
        doc.text(nombre_completo, 40, 190);
        doc.text("Rut:", 40, 210);
        doc.text(persona.Rut, 70, 210);
        doc.setFont("", "bold");
        doc.text("Presente", 40, 250);
        var parrafo1 = `La presente tiene por motivo, informar a Usted que con fecha ${fecha_plazo}, se ha decidido poner término a su Contrato de Trabajo a partir del día ${fecha_fin}, mediando 30 días entre la fecha de comunicación y término efectivo del contratos que usted tenía vigente con nuestra Empresa, en virtud de la causal dispuesta en el artículo 161 inciso 1° del Código del Trabajo, esto es, “Necesidades de la empresa”.`;
        var parrafo2 = "";
        if (parrafo !== "") {
            parrafo2 = 'Dicha causal se funda en ' + parrafo;
        }
        //var parrafo2 = 'Dicha causal se funda en ' + parrafo;
        var parrafo3 = `Producto de lo anterior, se ha debido adoptar una serie de medidas para redistribuir y reorganizar el personal que quedará.`;
        var parrafo4 = `Le informamos que sus cotizaciones previsionales se encuentran debidamente enteradas en las entidades correspondientes.`;
        var parrafo5 = `Su finiquito estará disponible a partir desde el ${fecha_fin_10}, en nuestras oficinas ubicadas en Calle Baquedano 647, Ciudad de Antofagasta.`;
        doc.setFont("", "normal");
        console.log("H Text", doc.getTextDimensions(parrafo1).h);
        console.log("W Text", doc.getTextDimensions(parrafo1).w);
        console.log([(doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20]);
        var y = 280;
        doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
        /* doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20; */
        let split = parrafo2.split('\n\n') //split up
        //logging every new line:
        split.forEach(function (item) {
            //console.log(item);
            doc.text(item, 40, y, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(item).h * (doc.getTextDimensions(item).w / 500)) + 12 + 20;
            console.log(y);
            if (y >= 660) {
                doc.addPage();
                y = 50;
            }
        });
        /* doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20; */
        doc.text(parrafo4, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo4).h * (doc.getTextDimensions(parrafo4).w / 500)) + 12 + 20;
        doc.text(parrafo5, 40, y, { maxWidth: 500, align: 'justify' });
        var text = "Sin otro particular, Atte.,",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
        doc.text(text, xOffset, 680);
        doc.setFont("", "bold");
        var text2 = "Depto. R.R.H.H.",
            xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
        doc.text(text2, xOffset2, 700);
        var text3 = "Constructora Ecora S.A.",
            xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
        doc.text(text3, xOffset3, 720);
        var text4 = "Rut.: 76.961.000-6",
            xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
        doc.text(text4, xOffset4, 740);
        var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
            xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
        doc.text(text5, xOffset5, 760);
        doc.output("dataurlnewwindow", "carta_desvinculacion_1611CA.pdf");
    }

    function pdf1611SA(parrafo) {
        var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
        var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
        var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");
        //var fecha_fin = moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY");
        var fecha_10 = Moment(calculo[0].fecha_finiquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        const doc = new jsPDF("p", "pt", "letter", true);
        doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
        doc.setFontSize(12);
        doc.setFont("", "bold");
        doc.text("Antofagasta", 375, 70);
        doc.setFont("", "normal");
        doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 440, 70);
        doc.text("Estimada(o):", 40, 170);
        doc.text(nombre_completo, 40, 190);
        doc.text("Rut:", 40, 210);
        doc.text(persona.Rut, 70, 210);
        doc.setFont("", "bold");
        doc.text("Presente", 40, 250);
        var parrafo1 = `La presente tiene por motivo, informar a Usted que con fecha ${fecha_fin}, se pone término al Contrato de Trabajo que usted tenía vigente con nuestra Empresa.  El término de dicho Contrato se acoge al Artículo 161 del Código del Trabajo, esto es "Por Necesidades de la Empresa".`;
        var parrafo2 = "";
        if (parrafo !== "") {
            parrafo2 = 'Dicha casual se funda en ' + parrafo;
        }
        //'Como es de su conocimiento, nuestra empresa se encuentra en un proceso de reestructuración y reorganización, este proceso ha motivado entre otras medidas, el término de proyectos recientes, lo que ha implicado la reducción de personal.';
        var parrafo3 = `Debido a que en su calidad de ${persona.recDescripcion} , cargo en el cual se desempeñó para el área de ${persona.ctoDescripcion} nos vemos en la necesidad de prescindir de sus servicios, agradeciendo desde ya su trabajo, esfuerzo y dedicación.`;
        var parrafo4 = `Le informamos que sus cotizaciones previsionales se encuentran debidamente enteradas en las entidades correspondientes.`;
        var parrafo5 = `Su finiquito estará disponible a partir desde el ${fecha_fin_10}, en nuestras oficinas ubicadas en Calle Baquedano 647, Ciudad de Antofagasta.`;
        doc.setFont("", "normal");
        console.log("H Text", doc.getTextDimensions(parrafo1).h);
        console.log("W Text", doc.getTextDimensions(parrafo1).w);
        console.log([(doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20]);
        var y = 280;
        doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
        /* doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20; */
        let split = parrafo2.split('\n\n') //split up
        //logging every new line:
        split.forEach(function (item) {
            //console.log(item);
            doc.text(item, 40, y, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(item).h * (doc.getTextDimensions(item).w / 500)) + 12 + 20;
            console.log(y);
            if (y >= 660) {
                doc.addPage();
                y = 50;
            }
        });
        /* doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20; */
        doc.text(parrafo4, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo4).h * (doc.getTextDimensions(parrafo4).w / 500)) + 12 + 20;
        doc.text(parrafo5, 40, y, { maxWidth: 500, align: 'justify' });
        var text = "Sin otro particular, Atte.,",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
        doc.text(text, xOffset, 680);
        doc.setFont("", "bold");
        var text2 = "Depto. R.R.H.H.",
            xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
        doc.text(text2, xOffset2, 700);
        var text3 = "Constructora Ecora S.A.",
            xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
        doc.text(text3, xOffset3, 720);
        var text4 = "Rut.: 76.961.000-6",
            xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
        doc.text(text4, xOffset4, 740);
        var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
            xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
        doc.text(text5, xOffset5, 760);
        doc.output("dataurlnewwindow", "carta_desvinculacion_1611SA.pdf");
    }

    function pdf1594(parrafo) {
        var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
        var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
        var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");//Moment(fechafiniquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_10 = Moment(fechafiniquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_hoy = moment(new Date()).format("DD-MMMM-YYYY");
        var fecha_hoy_10 = Moment(calculo[0].fecha_finiquito).businessAdd(11).format("DD-MMMM-YYYY");
        const doc = new jsPDF("p", "pt", "letter", true);
        doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
        doc.setFontSize(12);
        doc.setFont("", "bold");
        doc.text("Antofagasta", 375, 70);
        doc.setFont("", "normal");
        doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 440, 70);
        doc.text("Estimada(o):", 40, 170);
        doc.text(nombre_completo, 40, 190);
        doc.text("Rut:", 40, 210);
        doc.text(persona.Rut, 70, 210);
        doc.setFont("", "bold");
        doc.text("Presente", 40, 250);
        var parrafo1 = `La presente tiene por motivo, informar a Usted que con fecha ${fecha_fin}, se pone término al Contrato de Trabajo que usted tenía vigente con nuestra Empresa.  El término de dicho Contrato se acoge al Artículo 159 N°4 del Código del Trabajo, esto es "Vencimiento del plazo convenido en el contrato".`//`De conformidad con lo dispuesto en el artículo 162, inciso 4º, del Código del Trabajo, comunico a usted que, a contar del día de hoy ${fecha_hoy}, se ha resuelto poner término a su contrato de trabajo, por la causal legal prevista en el artículo 159, numero 4, del Código del Trabajo, esto es, “vencimiento del plazo convenido en el contrato”.`;
        var parrafo2 = "";
        if (parrafo !== "") {
            parrafo2 = 'Dicha causal se funda en ' + parrafo;
        }
        //var parrafo2 = 'Dicha causal se funda en ' + parrafo;
        var parrafo3 = `Le informamos además que sus cotizaciones previsionales se encuentran debidamente enteradas en las entidades correspondientes.`//`Luego, informo a usted que la determinación antes señalada, es decir, la de poner término a su contrato de trabajo, se fundamenta principalmente en el hecho de haber expirado el plazo fijado en su contrato, ${moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY")}; optándose por no prorrogar el mismo, cuya duración quedo debidamente establecida en su contrato de trabajo.`;
        var parrafo4 = ''//`En cuanto a sus cotizaciones previsionales, le informo que éstas se encuentran íntegramente pagadas hasta el último día del mes anterior al término del contrato, según acredito mediante certificado de Previred, que adjunto.`;
        var parrafo5 = `Su finiquito estará disponible a partir desde el ${fecha_fin_10}, en nuestras oficinas ubicadas en Calle Baquedano 647, Ciudad de Antofagasta.`;
        doc.setFont("", "normal");
        console.log("H Text", doc.getTextDimensions(parrafo1).h);
        console.log("W Text", doc.getTextDimensions(parrafo1).w);
        console.log([(doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20]);
        var y = 280;
        doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
        doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20;
        doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20;
        doc.text(parrafo4, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo4).h * (doc.getTextDimensions(parrafo4).w / 500)) + 12 + 20;
        doc.text(parrafo5, 40, y, { maxWidth: 500, align: 'justify' });
        var text = "Sin otro particular, Atte.,",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
        doc.text(text, xOffset, 680);
        doc.setFont("", "bold");
        var text2 = "Depto. R.R.H.H.",
            xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
        doc.text(text2, xOffset2, 700);
        var text3 = "Constructora Ecora S.A.",
            xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
        doc.text(text3, xOffset3, 720);
        var text4 = "Rut.: 76.961.000-6",
            xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
        doc.text(text4, xOffset4, 740);
        var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
            xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
        doc.text(text5, xOffset5, 760);
        doc.output("dataurlnewwindow", "carta_desvinculacion_1594.pdf");
    }

    function pdf1595(parrafo) {
        var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
        var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
        var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");
        //var fecha_fin = moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY");
        var fecha_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");//Moment(calculo[0].fecha_finiquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_termino_proyecto = moment(fechaterminoproyecto).format("DD-MMMM-YYYY");
        var fecha_hoy = moment(new Date()).format("DD-MMMM-YYYY");
        var fecha_hoy_10 = Moment(new Date()).businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_termino_contrato = moment(fechaterminocontrato).format("DD-MMMM-YYYY");
        var fecha_inicio_proyecto = moment(fechainicioproyecto).format("DD-MMMM-YYYY");
        const doc = new jsPDF("p", "pt", "letter", true);
        doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
        doc.setFontSize(12);
        doc.setFont("", "bold");
        doc.text("Antofagasta", 375, 70);
        doc.setFont("", "normal");
        doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 440, 70);
        doc.text("Estimada(o):", 40, 170);
        doc.text(nombre_completo, 40, 190);
        doc.text("Rut:", 40, 210);
        doc.text(persona.Rut, 70, 210);
        doc.setFont("", "bold");
        doc.text("Presente", 40, 250);
        var parrafo1 = `De conformidad con lo dispuesto en el artículo 159 N° 5 y 162 inciso 2° del Código del Trabajo, comunico a usted que, a contar del día de hoy ${fecha_hoy}, se ha decidido poner término al contrato de trabajo a plazo fijo a partir del día ${fecha_termino_contrato} próximo, por conclusión del trabajo o servicio que dio origen al contrato, consistente en el término de las labores correspondientes a ${persona.ctoDescripcion} (función) en el hito ${hito}, cuyo término aconteció con fecha ${fecha_termino_proyecto}, conforme la cláusula ${clausula} del contrato suscrito con fecha ${fecha_inicio_proyecto}.`;
        var parrafo2 = "";
        if (parrafo !== "") {
            parrafo2 = 'Dicha causal se funda en ' + parrafo;
        }
        //var parrafo2 = 'Dicha causal se funda en ' + parrafo;
        var parrafo3 = `Luego, informo a usted que la determinación antes señalada, es decir, la de poner término a su contrato de trabajo, se fundamenta principalmente en el hecho de haber culminado las funciones que le eran requeridas para la obra, debiendo prescindir de sus servicios.`;
        var parrafo31 = `Hacemos presente a usted que, en virtud de lo establecido en el inciso 4°, del artículo 162, del Código del Trabajo, adicional a las vacaciones proporcionales.`;
        var parrafo32 = `Así también, comunico a usted que a la indemnización antes señalada se han practicado las deducciones que correspondan por concepto de aportes efectuados por el empleador a la cuenta individual de cesantía.`
        var parrafo4 = `En cuanto a sus cotizaciones previsionales, le informo que éstas se encuentran íntegramente pagadas hasta el último día del mes anterior al término del contrato, según acredito mediante certificado de Previred, que adjunto.`;
        var parrafo5 = `Su finiquito estará disponible a partir desde el ${fecha_10}, en nuestras oficinas ubicadas en Calle Baquedano 647, Ciudad de Antofagasta.`;
        doc.setFont("", "normal");
        console.log("H Text", doc.getTextDimensions(parrafo1).h);
        console.log("W Text", doc.getTextDimensions(parrafo1).w);
        console.log([(doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20]);
        var y = 280;
        doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
        doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20;
        doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20;
        doc.text(parrafo31, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo31).h * (doc.getTextDimensions(parrafo31).w / 500)) + 12 + 20;
        doc.text(parrafo32, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20;
        doc.text(parrafo4, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo4).h * (doc.getTextDimensions(parrafo4).w / 500)) + 12 + 20;
        doc.text(parrafo5, 40, y, { maxWidth: 500, align: 'justify' });
        var text = "Sin otro particular, Atte.,",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
        doc.text(text, xOffset, 680);
        doc.setFont("", "bold");
        var text2 = "Depto. R.R.H.H.",
            xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
        doc.text(text2, xOffset2, 700);
        var text3 = "Constructora Ecora S.A.",
            xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
        doc.text(text3, xOffset3, 720);
        var text4 = "Rut.: 76.961.000-6",
            xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
        doc.text(text4, xOffset4, 740);
        var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
            xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
        doc.text(text5, xOffset5, 760);
        doc.output("dataurlnewwindow", "carta_desvinculacion_1595.pdf");
    }

    function pdf1603(parrafo) {
        var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
        var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
        var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");
        //var fecha_fin = moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY");
        var fecha_10 = Moment(calculo[0].fecha_finiquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_plazo = moment(fechaplazo).locale('es').format("DD-MMMM-YYYY");
        const doc = new jsPDF("p", "pt", "letter", true);
        doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
        doc.setFontSize(12);
        doc.setFont("", "bold");
        doc.text("Antofagasta", 375, 70);
        doc.setFont("", "normal");
        doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 440, 70);
        doc.text("Estimada(o):", 40, 170);
        doc.text(nombre_completo, 40, 190);
        doc.text("Rut:", 40, 210);
        doc.text(persona.Rut, 70, 210);
        doc.setFont("", "bold");
        doc.text("Presente", 40, 250);
        var parrafo1 = `La presente tiene por motivo, informar a Usted que con fecha ${fecha_fin}, se pone término al Contrato de Trabajo que usted tenía vigente con nuestra Empresa. El término de dicho Contrato se acoge al Art 160 N°3 No concurrencia del trabajador a sus labores sin causa justificada durante dos días seguidos, dos lunes en el mes o un total de tres días durante igual período de tiempo; asimismo, la falta injustificada, o sin aviso previo de parte del trabajador que tuviere a su cargo una actividad, faena o máquina cuyo abandono o paralización signifique una perturbación grave en la marcha de la obra, dicha causal se funda en que usted no se presentó a sus labores el día ${dia1}; ${dia2}; ${dia3}; sin manifestar a la fecha ningún justificativo que lo exima de presentarse a su trabajo.`;
        var parrafo2 = "";
        if (parrafo !== "") {
            parrafo2 = 'Dicha causal se funda en ' + parrafo;
        }
        //var parrafo2 = 'Dicha causal se funda en ' + parrafo;
        //var parrafo3 = `Producto de lo anterior, se ha debido adoptar una serie de medidas para redistribuir y reorganizar el personal que quedará.`;
        var parrafo4 = `Le informamos que sus cotizaciones previsionales se encuentran debidamente enteradas en las entidades correspondientes.`;
        var parrafo5 = `Su finiquito estará disponible a partir desde el ${fecha_fin_10}, en nuestras oficinas ubicadas en Calle Baquedano 647, Ciudad de Antofagasta.`;
        doc.setFont("", "normal");
        console.log("H Text", doc.getTextDimensions(parrafo1).h);
        console.log("W Text", doc.getTextDimensions(parrafo1).w);
        console.log([(doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20]);
        var y = 280;
        doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
        /* doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20; */
        let split = parrafo2.split('\n\n') //split up
        //logging every new line:
        split.forEach(function (item) {
            //console.log(item);
            doc.text(item, 40, y, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(item).h * (doc.getTextDimensions(item).w / 500)) + 12 + 20;
            console.log(y);
            if (y >= 660) {
                doc.addPage();
                y = 50;
            }
        });
        /* doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20; */
        doc.text(parrafo4, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo4).h * (doc.getTextDimensions(parrafo4).w / 500)) + 12 + 20;
        doc.text(parrafo5, 40, y, { maxWidth: 500, align: 'justify' });
        var text = "Sin otro particular, Atte.,",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
        doc.text(text, xOffset, 680);
        doc.setFont("", "bold");
        var text2 = "Depto. R.R.H.H.",
            xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
        doc.text(text2, xOffset2, 700);
        var text3 = "Constructora Ecora S.A.",
            xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
        doc.text(text3, xOffset3, 720);
        var text4 = "Rut.: 76.961.000-6",
            xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
        doc.text(text4, xOffset4, 740);
        var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
            xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
        doc.text(text5, xOffset5, 760);
        doc.output("dataurlnewwindow", "carta_desvinculacion_1603.pdf");
    }

    function pdf1591(parrafo) {
        var nombre_completo = persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno;
        var fecha_fin = moment(fechafiniquito).format("DD-MMMM-YYYY");
        var fecha_fin_10 = moment(calculaEntrega(new Date(fechafiniquito), 10, festivos)).format("DD-MMMM-YYYY");
        //var fecha_fin = moment(calculo[0].fecha_finiquito).format("DD-MMMM-YYYY");
        var fecha_10 = Moment(calculo[0].fecha_finiquito, "DD-MM-YYYY").businessAdd(10).format("DD-MMMM-YYYY");
        var fecha_plazo = moment(fechaplazo).locale('es').format("DD-MMMM-YYYY");
        var fecha_contrato_inicial = moment(persona.FechaContratoInicial).format("DD-MMMM-YYYY");
        const doc = new jsPDF("p", "pt", "letter", true);
        doc.addImage("/img/ecora_movil_logo.png", "JPEG", 15, 40, 150, 68);
        doc.setFontSize(12);
        doc.setFont("", "bold");
        doc.text("Antofagasta", 375, 70);
        doc.setFont("", "normal");
        doc.text(", " + moment(new Date()).format("DD-MMMM-YYYY"), 440, 70);
        doc.text("Estimada(o):", 40, 170);
        doc.text(nombre_completo, 40, 190);
        doc.text("Rut:", 40, 210);
        doc.text(persona.Rut, 70, 210);
        doc.setFont("", "bold");
        doc.text("Presente", 40, 250);
        var parrafo1 = `En Antofagasta, a 15 de junio de 2021 entre Constructora Ecora S.A., Rut 76.961.000-6, con domicilio en calle Baquedano 647, Antofagasta, representada por OSCAR RODRIGO URREA MARCOLETA, Rut 10.604.347-7, y don ${nombre_completo}, Rut: ${persona.Rut}, se han acordado lo que a continuación se expone:`;
        var parrafo2 = `1.	Que, luego de una conversación entre las partes, se ha acordado de común acuerdo, mediante este documento y en este acto, poner término al contrato de trabajo que los vinculaba desde el ${fecha_contrato_inicial}, de conformidad al artículo 159 N° 1 del Código del Trabajo, esto es, “mutuo acuerdo de las partes”.`;
        if (parrafo !== "") {
            parrafo2 = 'Dicha causal se funda en ' + parrafo;
        }
        //var parrafo2 = 'Dicha causal se funda en ' + parrafo;
        //var parrafo3 = `Producto de lo anterior, se ha debido adoptar una serie de medidas para redistribuir y reorganizar el personal que quedará.`;
        var parrafo4 = `2.	La fecha de término de la relación laboral será el día ${fecha_fin}`;
        var parrafo5 = `Se firma el presente acuerdo en 2 ejemplares, quedando 1 en poder del empleador y 1 poder del trabajador.`;
        doc.setFont("", "normal");
        console.log("H Text", doc.getTextDimensions(parrafo1).h);
        console.log("W Text", doc.getTextDimensions(parrafo1).w);
        console.log([(doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20]);
        var y = 280;
        doc.text(parrafo1, 40, 280, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo1).h * (doc.getTextDimensions(parrafo1).w / 500)) + 12 + 20;
        doc.text(parrafo2, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo2).h * (doc.getTextDimensions(parrafo2).w / 500)) + 12 + 20;
        //let split=parrafo2.split('\n\n') //split up
        //logging every new line:
        /* split.forEach(function(item){
            //console.log(item);
            doc.text(item, 40, y, { maxWidth: 500, align: 'justify' });
            y = y + (doc.getTextDimensions(item).h * (doc.getTextDimensions(item).w / 500)) + 12 + 20;
            console.log(y);
            if(y >= 660) {
                doc.addPage();
                y = 50;
            }
        }); */
        /* doc.text(parrafo3, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo3).h * (doc.getTextDimensions(parrafo3).w / 500)) + 12 + 20; */
        doc.text(parrafo4, 40, y, { maxWidth: 500, align: 'justify' });
        y = y + (doc.getTextDimensions(parrafo4).h * (doc.getTextDimensions(parrafo4).w / 500)) + 12 + 20;
        doc.text(parrafo5, 40, y, { maxWidth: 500, align: 'justify' });
        /* var text = "Sin otro particular, Atte.,",
            xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text) * doc.internal.getFontSize() / 2);
        doc.text(text, xOffset, 660);
        doc.setFont("", "bold");
        var text2 = "Depto. R.R.H.H.",
            xOffset2 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / 2);
        doc.text(text2, xOffset2, 720);
        var text3 = "Constructora Ecora S.A.",
            xOffset3 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text3) * doc.internal.getFontSize() / 2);
        doc.text(text3, xOffset3, 740);
        var text4 = "Rut.: 76.961.000-6",
            xOffset4 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text4) * doc.internal.getFontSize() / 2);
        doc.text(text4, xOffset4, 760);
        var text5 = "Baquedano 647-Antofagasta- Fono (55)-2552410",
            xOffset5 = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(text5) * doc.internal.getFontSize() / 2);
        doc.text(text5, xOffset5, 780); */
        //Empresa
        doc.text("_______________________", 100, 660);
        doc.text("  Constructora Ecora S.A.", 100, 680);
        doc.text("     RUT: 76.961.000-6", 100, 700);
        //Trabajdor
        doc.text("           _____________________", 320, 660);
        doc.text("  " + nombre_completo, 320, 680);
        doc.text("             RUT: " + persona.Rut, 320, 700);
        doc.output("dataurlnewwindow", "carta_desvinculacion_1603.pdf");
    }

    const modificar = () => {
        navigate("/finiquito/" + persona.Rut + "/" + causal.id);
    }

    /** Data de Documentos */
    const columns = [{
        field: "nombre", headerName: "Nombre", flex: 1
    }, {
        field: "ruta", headerName: "Descarga", flex: 1, renderCell: (cellValues) => {
            return (
                <a href={cellValues.row.ruta} target="_blank"><Button variant="contained" endIcon={<AttachFileIcon />}>Descargar</Button></a>
            );
        }
    }];

    const actualizar_fechafiniquito = () => {
        setLoadingbutton(true);
        console.log({
            "fecha nueva": fechafiniquito,
            "Id Persona": persona.id,
            "calculos": calculo
        });
        for (var c in calculo) {
            calculoService.update(calculo[c].id, { fecha_finiquito: fechafiniquito })
                .then(resp => {
                    console.log(resp)
                    setLoadingbutton(false);
                    toast.success("Fecha actualizada con exito!!", {
                        style: {
                            borderRadius: 5
                        }
                    });
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    return (
        loading ? (
            <div>
                <div className="d-flex justify-content-center">
                    <Oval
                        heigth="100"
                        width="100"
                        color='blue'
                        ariaLabel='loading'
                    />
                </div>
                <p className="text-center">Cargando ...</p>
            </div>
        ) : (
            <>
                <Toaster />
                <div className="row">
                    <div className="col-12">
                        <div className="text-center">
                            <h2>Datos de Trabajador</h2>
                        </div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>Rut:</td>
                                    <td>{persona.Rut}</td>
                                </tr>
                                <tr>
                                    <td>Nombre</td>
                                    <td>{persona ? persona.perNombre1 + " " + persona.perNombre2 + " " + persona.perApPaterno + " " + persona.perApMaterno : ""}</td>
                                </tr>
                                <tr>
                                    <td>Unidad de Negocio:</td>
                                    <td>{persona.ctoDescripcion}</td>
                                </tr>
                                <tr>
                                    <td>Cargo:</td>
                                    <td>{persona.recDescripcion}</td>
                                </tr>
                                <tr>
                                    <td>Fecha Ingreso:</td>
                                    <td>{persona ? moment(persona.FechaContratoInicial).local().format('DD/MM/YYYY') : ""}</td>
                                </tr>
                                <tr>
                                    <td>Prceso de Desvinculación</td>
                                    <td className={persona.estado_desv === "En Proceso" ? persona.estado_desv === "Desvinculado" ? "text-danger" : "text-warning" : ""}>{persona.estado_desv}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <h2 className="text-center">Datos Causal</h2>
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>Causal de Despido:</td>
                                <td>{causal.descripcion}</td>
                            </tr>
                            <tr>
                                <td>Fecha Solicitud:</td>
                                <td>{moment(causal.fecha_ingreso).local().format('DD/MM/YYYY hh:mm:ss')}</td>
                            </tr>
                            <tr>
                                <td>Comentarios:</td>
                                <td>{causal.comentario}</td>
                            </tr>
                            <tr>
                                <td>Comentarios RRHH:</td>
                                <td>{causal.comentario_rrhh}</td>
                            </tr>
                            <tr>
                                <td>Fecha Finiquito:</td>
                                <td>{calculo[2] ? moment(calculo[2].fecha_finiquito).format("DD-MM-YYYY") : ""}</td>
                            </tr>
                            <tr>
                                <td>Turno:</td>
                                <td>{calculo[2] ? calculo[2].turno : ""}</td>
                            </tr>
                            <tr>
                                <td>Ultimo día efectivo trabajado:</td>
                                <td>{calculo[2] ? moment(calculo[2].ultimo_dia).format("DD-MM-YYYY") : ""}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="text-center">
                        <h2>Datos RRHH</h2>
                    </div>
                    <div className="col-8">
                        <table className="table">
                            <tbody>
                                {calculo.map((c, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{c.nombre}</td>
                                            <td>{c.valor}</td>
                                            <td>{c.detalle}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <h3 style={{ textAlign: "center" }}>Documentos Complementarios Desvinculación</h3>
                        <div style={{ height: 250, width: '100%' }}>
                            <DataGrid
                                sx={{
                                    boxShadow: 2,
                                    border: 2,
                                    borderColor: 'primary.light',
                                    '& .MuiDataGrid-cell:hover': {
                                        color: 'primary.main',
                                    },
                                }}
                                rows={persona ? persona.documento : []}
                                columns={columns}
                                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            />
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="text-center">
                        <h2>CONSIDERACIONES PARA EL CALCULO DE FINIQUITO DEL TRABAJADOR</h2>
                    </div>
                    <div className="col-8">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>CONSIDERACIONES</th>
                                    <th>SI O NO</th>
                                    <th>DETALLE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Prestamos vigentes (Finanzas)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="vigentes" value="SI" id="chkprestamo1" onChange={(e) => setPrestamo(e.target.value)} checked={prestamo === "SI"} />
                                            <label className="form-check-label" htmlFor="chkprestamo1">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="vigentes" value="NO" id="chkprestamo2" onChange={(e) => setPrestamo(e.target.value)} checked={prestamo === "NO"} />
                                            <label className="form-check-label" htmlFor="chkprestamo2">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control" value={detallePrestamo} onChange={(e) => setDetallePrestamo(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Entrega de equipos (Secretaria)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="equipo" value="SI" id="chkequipos1" onChange={(e) => setEquipo(e.target.value)} checked={equipo === "SI"} />
                                            <label className="form-check-label" htmlFor="chkequipos1">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="equipo" value="NO" id="chkequipos2" onChange={(e) => setEquipo(e.target.value)} checked={equipo === "NO"} />
                                            <label className="form-check-label" htmlFor="chkequipos2">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control" value={detalleEquipo} onChange={(e) => setDetalleEquipo(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fondo por rendir (Finanzas)</td>
                                    <td>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="rendir" value="SI" id="chkrendir1" onChange={(e) => setRendir(e.target.value)} checked={rendir === "SI"} />
                                            <label className="form-check-label" htmlFor="chkrendir1">
                                                SI
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="rendir" value="NO" id="chkrendir2" onChange={(e) => setRendir(e.target.value)} checked={rendir === "NO"} />
                                            <label className="form-check-label" htmlFor="chkrendir2">
                                                NO
                                            </label>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" className="form-control" value={detalleRendir} onChange={(e) => setDetalleRendir(e.target.value)} />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fecha Finiquito:</td>
                                    <td>
                                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                            <DatePicker
                                                label="Fecha Finiquito"
                                                value={fechafiniquito}
                                                onChange={(newValue) => setFechafiniquito(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </td>
                                    <td><button className="btn btn-secondary" onClick={() => actualizar_fechafiniquito()}>{loadginButton ? <BeatLoader color="white" /> : "ACTUALIZAR"}</button></td>
                                </tr>
                            </tbody>
                        </table>
                        {causal.nombre === "Art 159 N4" || causal.nombre === "Art 159 N5" || causal.nombre === "Art 160 N1" ? (
                            <>
                                <div className="mt-3"></div>
                                <div className="hstack gap-2 border">
                                    <label className="form-label ms-3">Con aviso?</label>
                                    <input type="checkbox" className="form-check-input" onChange={(e) => setAviso(e.target.checked)} />
                                </div>
                            </>
                        ) : ""}
                        <div className="mt-3">
                            {aviso ? (
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                    <DatePicker
                                        label="Fecha Plazo"
                                        value={fechaplazo}
                                        onChange={(newValue) => setFechaPlazo(newValue)}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            ) : ""}
                        </div>
                        <div className="mt-3">
                            {causal.nombre === "Art 159 N5" ? (
                                <>
                                    <Grid container direction="row" spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                                <DatePicker
                                                    label="Fecha Termino de Contrato"
                                                    value={fechaterminocontrato}
                                                    onChange={(newValue) => setFechaTerminoContrato(newValue)}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                                <DatePicker
                                                    label="Fecha Inicio de Proyecto"
                                                    value={fechainicioproyecto}
                                                    onChange={(newValue) => setFechaInicioProyecto(newValue)}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                                                <DatePicker
                                                    label="Fecha Termino de Proyecto"
                                                    value={fechaterminoproyecto}
                                                    onChange={(newValue) => setFechaTerminoProyecto(newValue)}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            {/* <TextField label="Hito" required onChange={(e) => setHito(e.target.value)} /> */}
                                            <FormControl fullWidth>
                                                <InputLabel id="select-mes">Hito</InputLabel>
                                                <Select
                                                    labelId="select-mes"
                                                    id="mes"
                                                    label="Mes"
                                                    onChange={(e) => setHito(e.target.value)}
                                                    required
                                                >
                                                    <MenuItem value={"Termino Fundaciones"}>Termino Fundaciones</MenuItem>
                                                    <MenuItem value={"Término Obra Gruesa"}>Término Obra Gruesa</MenuItem>
                                                    <MenuItem value={"Termino Especialidad Sanitaria"}>Termino Especialidad Sanitaria</MenuItem>
                                                    <MenuItem value={"Termino Especialidad Eléctrica y/o Instrumentación"}>Termino Especialidad Eléctrica y/o Instrumentación</MenuItem>
                                                    <MenuItem value={"Termino Especialidad Mecánico Piping"}>Termino Especialidad Mecánico Piping</MenuItem>
                                                    <MenuItem value={"Termino Montaje"}>Termino Montaje</MenuItem>
                                                    <MenuItem value={"Termino de Proyecto"}>Termino de Proyecto</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField label="Clausula" required onChange={(e) => setClausula(e.target.value)} />
                                        </Grid>
                                    </Grid>
                                </>
                            ) : ""}
                        </div>
                        <div className="mt-3">
                            {causal.nombre === "Art 160 N3" ? (
                                <>
                                    <TextField
                                        label="Día 1"
                                        name="dia1"
                                        onChange={(e) => setDia1(e.target.value)}
                                    />
                                    <TextField
                                        label="Día 2"
                                        name="dia2"
                                        onChange={(e) => setDia2(e.target.value)}
                                    />
                                    <TextField
                                        label="Día 3"
                                        name="dia2"
                                        onChange={(e) => setDia3(e.target.value)}
                                    />
                                </>
                            ) : ""}
                        </div>
                        <div className="mt-3"></div>
                        {causal.nombre === "Art 159 N5" || causal.nombre === "Art 159 N6" || causal.nombre === "Art 160 N1" || causal.nombre === "Art 160 N2" || causal.nombre === "Art 160 N3" || causal.nombre === "Art 160 N4" || causal.nombre === "Art 160 N5" || causal.nombre === "Art 160 N6" || causal.nombre === "Art 160 N7" || causal.nombre === "Art 161 N1" || causal.nombre === "Art 161 N2" ? (
                            <>
                                <label className="form-label">Dicha casual se funda en:</label>
                                <textarea placeholder="Fundamentos causal ...." className="form-control" rows={10} onChange={(e) => setParrafo(e.target.value)}></textarea>
                                <div className="mt-3"></div>
                            </>
                        ) : ""}

                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-8">
                        <div className="mb-3">
                            <SignatureCanvas
                                canvasProps={{
                                    className: "sginatureCanvas"
                                }}
                                ref={(ref) => { setSigPad(ref) }}
                            />
                        </div>
                        <div class="vstack gap-2 col-md-5 mx-auto">
                            <button className="btn btn-secondary" onClick={limpiarFirma} >Limpiar Firma</button>
                            <button className="btn btn-primary" onClick={Ingresar}>Ingreso Temporal (V. BARREDA)</button>
                            {/* <button className="btn btn-primary" onClick={Ingresar_cdiaz} disabled={persona.estado_desv == " Etapa" ? false : true}>Ingreso Temporal (C. DIAZ)</button> */}
                            <button className="btn btn-primary" onClick={Ingresar_cjaramillo} disabled={persona.estado_desv == "En Área RRLL" ? false : true}>Ingreso Temporal (C. JARAMILLO)</button>
                            <button className="btn btn-primary" onClick={finalizar} disabled={persona.estado_desv == "En Finanzas 3 (Finiquito)" ? false : true}>Finalizar</button>
                            <button className="btn btn-success" onClick={crear_carta}>Descargar Carta</button>
                            {/* <button className="btn btn-danger" onClick={openModal}>Rechazar</button> */}
                            <button className="btn btn-danger" onClick={modificar}>Modificar</button>
                        </div>
                        {/* <div className="bd-example">
                        <button className="btn btn-primary" onClick={Ingresar}>Ingresar</button>
                        <button className="btn btn-secondary" onClick={limpiarFirma} >Limpiar Firma</button>
                    </div> */}
                    </div>
                </div>
                <div className="row justify-content-center mt-3">
                    {aprobado.map((a, i) => {
                        var data_uri = "data:image/png;base64," + a.firma;
                        return (
                            <div className="col-4" key={i}>
                                <img src={data_uri} className="signatureShow" width="100%" height="250" />
                                <div className="form-text">
                                    <p className="text-center">{a.tipo}</p>
                                </div>
                            </div>
                        )
                    })}
                    {/* <div className="col-4">
                    <p className="signatureShow">FIRMA</p>
                </div> */}
                </div>
                {/*  <div className="row">
                <button className="btn btn-success" onClick={crear_carta}>Descargar Carta</button>
            </div> */}
                {/** Modal para ingresasr rechazo de motivos */}
                <Modal
                    open={open}
                    onClose={closeModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" align="center" style={{ marginBottom: 10 }}>
                            Ingresar Motivo de Rechazo
                        </Typography>
                        {/* <FormGroup>
                        <FormControlLabel control={<Checkbox onChange={(e)=>onChangeCarta(e)} />} label="Carta de aviso?" />
                    </FormGroup> */}
                        <Stack spacing={2} direction="row">
                            <TextField
                                label="Motivo Rechazo"
                                /* value={nombrearchivo} */
                                onChange={(e) => setMotivoRechazo(e.target.value)}
                            /* disabled={carta} */
                            />
                            <LoadingButton
                                color="secondary"
                                //onClick={handleClick}
                                //loading={loading}
                                loadingPosition="start"
                                startIcon={<SaveIcon />}
                                variant="contained"
                                onClick={rechazar}
                            >
                                Rechazar
                            </LoadingButton>
                        </Stack>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            Ingeso de documento a la hoja de vida del trabajador.
                        </Typography>
                    </Box>
                </Modal>
            </>
        )
    )

}

export default function Finiquitopt3Snack() {
    return (
        <SnackbarProvider maxSnack={3}>
            <Finiquitopt3 />
        </SnackbarProvider>
    )
};